module.exports = function () {
    return {
        event: 'BWSAUcompetitionSubmitted',
        eventContext: {}
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/competitions/atmmapper/competition-submitted.js
 **/